import React from 'react';

export const Bold = (props) => (
  <svg
    fill="none"
    height="24"
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M8.168 18V6.432H12.16C12.9173 6.432 13.5627 6.504 14.096 6.648C14.6347 6.792 15.0747 6.99733 15.416 7.264C15.7627 7.53067 16.016 7.85333 16.176 8.232C16.336 8.61067 16.416 9.03733 16.416 9.512C16.416 9.784 16.376 10.0453 16.296 10.296C16.216 10.5413 16.0907 10.7733 15.92 10.992C15.7547 11.2053 15.5413 11.4 15.28 11.576C15.024 11.752 14.7173 11.9013 14.36 12.024C15.9493 12.3813 16.744 13.24 16.744 14.6C16.744 15.0907 16.6507 15.544 16.464 15.96C16.2773 16.376 16.0053 16.736 15.648 17.04C15.2907 17.3387 14.8507 17.5733 14.328 17.744C13.8053 17.9147 13.208 18 12.536 18H8.168ZM10.32 12.928V16.32H12.504C12.904 16.32 13.2373 16.272 13.504 16.176C13.776 16.08 13.992 15.952 14.152 15.792C14.3173 15.632 14.4347 15.4453 14.504 15.232C14.5787 15.0187 14.616 14.792 14.616 14.552C14.616 14.3013 14.576 14.0773 14.496 13.88C14.416 13.6773 14.2907 13.5067 14.12 13.368C13.9493 13.224 13.7307 13.1147 13.464 13.04C13.1973 12.9653 12.8747 12.928 12.496 12.928H10.32ZM10.32 11.44H12.04C12.7707 11.44 13.3253 11.3067 13.704 11.04C14.0827 10.7733 14.272 10.3493 14.272 9.768C14.272 9.16533 14.1013 8.736 13.76 8.48C13.4187 8.224 12.8853 8.096 12.16 8.096H10.32V11.44Z"
      fill="black"
    />
  </svg>
);
